import { resetActionModalContent, setActionModalContent } from '../../slice';
import { Store } from '../../store';

export const resetActionModal = () => {
    Store.dispatch(resetActionModalContent());
};

export const setActionModal = obj => {
    Store.dispatch(setActionModalContent(obj));
};
